<div class="booking-payment-element">
    @if (errorMessage(); as error) {
        <div
            class="alert alert-danger mb-0"
            role="alert"
            data-testid="booking-payment-error"
        >
            {{ error }}
        </div>
    }

    <div
        [id]="applePayId"
        [class.d-none]="!walletPaymentAvailable()"
        data-testid="booking-payment-apple-pay"
    ></div>
    <div
        [id]="googlePayId"
        [class.d-none]="!walletPaymentAvailable() || paymentAccount()?.usesDojo()"
        data-testid="booking-payment-google-pay"
    ></div>

    @if (usesHostedCheckout()) {
        <p class="text-secondary mb-0" data-testid="booking-payment-hosted-checkout">
            After continuing, you&rsquo;ll add your card details securely on Dojo.
        </p>
    } @else {
        <div
            class="booking-payment-card-container"
            [class.booking-payment-card-container-dojo]="paymentAccount()?.usesDojo()"
        >
            <div
                [id]="cardFormId"
                [style.visibility]="!isReady() ? 'hidden' : null"
            ></div>
            @if (!isReady() && !errorMessage()) {
                <div
                    class="booking-payment-spinner"
                    role="status"
                    data-testid="booking-payment-spinner"
                >
                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <span>Loading secure payment details&hellip;</span>
                </div>
            }
        </div>
    }

    @if (requiresFutureChargeConsent()) {
        <div class="form-check hstack gap-3">
            <input
                id="{{ cardFormId }}-future-charge-consent"
                class="form-check-input"
                type="checkbox"
                required
                [checked]="futureChargeConsentGiven()"
                (change)="futureChargeConsentGiven.set($any($event.target).checked)"
                data-testid="booking-payment-future-charge-consent"
            />
            <label
                class="form-check-label"
                [for]="cardFormId + '-future-charge-consent'"
            >
                {{ paymentAccount()?.usesTeya() ? 'I consent to cancellation or no-show charges totalling up to' : 'I consent to one cancellation or no-show charge of up to' }}
                <strong>{{ null | currencyUnit : futureChargeAmount() ?? undefined : currencyCode() }}</strong>
                being taken from this card under the venue's policy.
            </label>
        </div>
    }
</div>
